import ResumenGastoContainer from './ResumenGastoContainer';
export default ResumenGastoContainer;
